import { useState, useEffect } from 'react';

export interface UseTimerReturn {
  elapsed: string; // HH:MM:SS format
  seconds: number;
}

export function useTimer(startTime: number | null): UseTimerReturn {
  const [elapsed, setElapsed] = useState<string>('00:00:00');
  const [seconds, setSeconds] = useState<number>(0);

  useEffect(() => {
    if (!startTime) {
      setElapsed('00:00:00');
      setSeconds(0);
      return;
    }

    const updateTimer = () => {
      const now = Date.now();
      const diff = Math.floor((now - startTime) / 1000);
      setSeconds(diff);

      const hours = Math.floor(diff / 3600);
      const minutes = Math.floor((diff % 3600) / 60);
      const secs = diff % 60;

      const formatted = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
      setElapsed(formatted);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  return { elapsed, seconds };
}


